export default [{
    value:'',
    label:'全部'
},{
    value:'1',
    label:'到机构'
},{
    value:'2',
    label:'到会员'
},{
    value:'3',
    label:'到营销账户'
},{
    value:'4',
    label:'到奖励金账户'
},{
    value:'5',
    label:'手动分润'
},{
    value:'6',
    label:'会员到会员'
},];



// WEBPACK FOOTER //
// ./src/service/constant/AccAdjTypes.js